/* eslint-disable import/first */
import React from 'react';
import { TextField, Grid } from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Check, Info } from '../../components/Icons';
import Button from '@material-ui/core/Button';
import { createMuiTheme, jssPreset, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';
const { selectCountryValidations } = Slices.configSlice;
const { sendOtp } = Slices.authSlice;
import CountrySelection from '../../components/CountryDropdown';
const { getCurrentProfile, selectCurrentCountry, selectProfileStatus } = Slices.profileSlice;
import { create } from 'jss';
import Cookies from 'js-cookie';
import rtl from 'jss-rtl';
import ClassNames from 'classnames';
import css from './index.module.scss';
import { useNavigate } from '@reach/router';

export const MobileNumberInput = ({
  disableButton,
  countryCode,
  value,
  onChange,
  page,
  maxLength,
  validateError,
  phoneError,
  showCountryDropDown = true,
  hideName = false,
  hideCountrySelection = false,
  overrideCountry = '',
  phoneVerified,
  verifiedEmail,
  oldLocation,
}) => {
  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const config = useSelector((state) => state.config);
  const profile = useSelector(getCurrentProfile);
  const profileStatus = useSelector(selectProfileStatus);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, overrideCountry || country)
  );
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const [isRtl] = React.useState(Cookies.get('local') === 'ar' ? rtlTheme : ltrTheme);
  const [validationText, setValidationText] = React.useState('');
  const [validateMe, setValidateMe] = React.useState(false);
  const onlyNumbers = (evt) => {
    var ASCIICode = evt.which ? evt.which : evt.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) evt.preventDefault();
    return true;
  };
  React.useEffect(() => {
    const text = config.data?.data?.errorMessages?.VALIDATION['INVALID_PHONE_NO'];
    setValidationText(text);
  }, [config]);
  React.useEffect(() => {
    if (phoneError) {
      const text = config.data?.data?.errorMessages?.VALIDATION['INVALID_PHONE_NO'];
      setValidationText((prev) => text);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneError]);

  const activeDiv = page === 'login' || page === 'addNumber' || page === 'guest' ? false : true;
  const checkLength = (event) => {
    if (event?.target?.value?.length !== countryValidations?.phnLength) {
      const text = config.data?.data?.errorMessages?.VALIDATION['INVALID_PHONE_NO'];

      setValidationText(text);
      setValidateMe(true);
    } else {
      if (
        !value?.match(countryValidations?.phnRegex) ||
        !value?.match(countryValidations?.phnRegex)
      ) {
        const text = config.data?.data?.errorMessages?.VALIDATION['INVALID_PHONE_NO'];
        setValidationText(text);

        setValidateMe(true);
      } else {
        setValidateMe(false);
      }
    }
  };
  const handleVerify = () => {
    dispatch(
      sendOtp({
        cCode: profile?.cCode,
        phnNo: profile?.phnNo,
        otpVia: 'PHONE',
        sendOtpVia: 'SOCIAL',
        country: profile?.country.toUpperCase(),
      })
    )
      .then((resp) => {
        navigate(`/${intl.locale}/verifyOTP`, {
          replace: true,
          state: {
            cCode: countryValidations?.defaultCCode,
            phnNo: profile?.phnNo,
            component: 'login',
            isDisableEdit: true,
            verifiedEmail: page === 'create-profile' ? verifiedEmail : null,
          },
        });
      })
      .catch((error) => {
        // TODO: Handle send otp error
      });
  };

  return (
    <StylesProvider jss={jss}>
      <ThemeProvider theme={isRtl}>
        <Grid
          //className={css.mobileInput}
          //style={{ direction: Cookies.get('local') === 'ar' ? 'rtl' : 'ltr' }}
          className={` ${css.mobileInputRoot} ${
            Cookies.get('local') === 'ar' ? css.arabicView : css.enView
          }`}
        >
          {!hideCountrySelection && (
            <CountrySelection
              overrideCountry={overrideCountry}
              selectCurrentCountry={page === 'addNumber'}
              hideName={hideName}
              showCountryDropDown={showCountryDropDown}
              countryCode={countryCode}
            />
          )}
          <Grid
            className={ClassNames(css.mobileInputArea, {
              [css.disableDiv]: activeDiv,
            })}
          >
            <TextField
              fullWidth
              disabled={activeDiv && phoneVerified}
              error={
                (page !== 'login' &&
                  !value?.match(countryValidations?.phnRegex) &&
                  value?.length !== countryValidations?.phnLength &&
                  value !== '' &&
                  validationText) ||
                phoneError ||
                validateMe
              }
              // label={
              //   activeDiv ? null : (
              //     <FormattedMessage id="mobileNumber" defaultMessage="MOBILE NUMBER" />
              //   )
              // }
              placeholder={intl.formatMessage({ id: 'mobileNumber' })}
              name="mobile"
              value={value || ''}
              onChange={onChange}
              className={
                page === 'guest'
                  ? css.guestInput
                  : page === 'create-profile'
                  ? css.createProfile
                  : css.loginNumber
              }
              type="number"
              helperText={
                page !== 'login' &&
                ((!value?.match(countryValidations?.phnRegex) &&
                  value !== '' &&
                  value?.length !== countryValidations?.phnLength &&
                  validationText) ||
                  (phoneError && validationText) ||
                  (validateMe && validationText))
              }
              onBlur={(event) => checkLength(event)}
              onKeyPress={(event) => onlyNumbers(event)}
              InputProps={{
                inputMode: 'numeric',
                maxLength: maxLength || countryValidations?.phnLength,
                disableUnderline: true,
              }}
              inputProps={{
                inputMode: 'numeric',
                maxLength: maxLength || countryValidations?.phnLength,
                disableUnderline: true,
              }}
              onInput={(e) => {
                e.target.value = e.target.value.trim().slice(0, countryValidations.phnLength);
              }}
            />

            {page !== 'login' && profileStatus === 'succeeded' ? (
              <>
                {page !== 'guest' && phoneVerified ? (
                  <div className={css.checkPhone}>
                    <Check />
                  </div>
                ) : (
                  <>
                    {phoneVerified === 0 &&
                    (!overrideCountry || overrideCountry.toLowerCase() === country.toLowerCase()) &&
                    page !== 'create-profile' ? (
                      <Button
                        variant="outlined"
                        className={css.cancelButton}
                        onClick={handleVerify}
                      >
                        <FormattedMessage id="loginVerify" defaultMessage="Verify" />
                      </Button>
                    ) : page === 'create-profile' && phoneVerified === 0 ? (
                      <Info />
                    ) : (
                      ''
                    )}
                  </>
                )}
              </>
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default MobileNumberInput;
